import { Avatar, Box, Flex, Text, Card } from "@chakra-ui/react";
import { GhostButton } from "../../components/TablePageShell";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RelationShip } from "../../interfaes/student";
import { Roles } from "../../interfaes/user";
import { IEP } from "../../interfaes/iep";
import { useLocation, useParams } from "react-router-dom";
import StrengthAndLimitationView from "./strengthAndLimitation";
import CheckListAreas from "./CheckListAreas";
import GoalsAndObjectivesView from "./GoalsAndObjectives";
import ReviewView from "./ReviewView";
import { onGetSingleIEP } from "../../http/iepAPis";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function IepSteps() {
    const { t } = useTranslation('iep');
    const { state } = useLocation();
    const { step } = useParams();
    const [iepFormAPI, setIEPFormAPI] = useState<IEP | undefined>(undefined);
    const { iepId } = useParams();
    const navigate = useNavigate();


    const getIEP = async () => {
        if (iepId && state) {
            try {
                const response = await onGetSingleIEP(state?.student.studentId, iepId);
                setIEPFormAPI({ ...response.data });
            } catch (e) {
                console.log(e);
            }
        }
    }
    useEffect(() => {
        getIEP()
    }, [iepId]);



    const getComponentByStep = () => {
        if (iepFormAPI) {
            const iep: IEP = iepFormAPI;
            switch (step) {
                case 'step1':
                    return <StrengthAndLimitationView strengthAndLimitation={iep.iepSteps?.strengthAndLimitations || []}
                        iepId={iep?.iepId ? iep.iepId : ''} onGetData={getIEP}
                        isCompleted={iep.completedSteps?.includes(1)} />;
                case 'step2':
                    return <CheckListAreas checkListArea={iep.iepSteps?.checkListAreas || []}
                        checkListAreaOld={iep.iepSteps?.checkListAreas || []}
                        iepId={iep?.iepId ? iep.iepId : ''} title={t('step2')}
                        subTitle={t('step2Title')} onGetData={getIEP} step={2}
                        isCompleted={iep.completedSteps?.includes(2)} />;

                case 'step3':
                    return <GoalsAndObjectivesView goalsAndObjectives={iep.iepSteps?.goalsAndObjectives}
                        iepId={iep?.iepId ? iep.iepId : ''} onGetData={getIEP}
                        isCompleted={iep.completedSteps?.includes(3)}
                        goalId={undefined}
                        reviewStep={0}
                        onUpdateObjetives={() => { }}
                    />;
                case 'step4':
                    return <ReviewView title={t('step4')} subTitle={t('step4Title')} iepId={iep?.iepId ? iep.iepId : ''}
                        firstReview={iep.iepSteps?.firstReview}
                        secondReview={iep.iepSteps?.secondReview}
                        finalReview={iep.iepSteps?.finalReview}
                        mainReview={iep.iepSteps?.firstReview}
                        onGetData={getIEP} step={4}
                        isCompleted={iep.completedSteps?.includes(4)}
                        goalsAndObjectives={iep.iepSteps?.goalsAndObjectives}
                    />;
                case 'step5':
                    return <ReviewView title={t('step5')} subTitle={t('step5Title')} iepId={iep?.iepId ? iep.iepId : ''}
                        firstReview={iep.iepSteps?.firstReview}
                        secondReview={iep.iepSteps?.secondReview}
                        finalReview={iep.iepSteps?.finalReview}
                        mainReview={iep.iepSteps?.secondReview}
                        onGetData={getIEP} step={5}
                        isCompleted={iep.completedSteps?.includes(5)}
                        goalsAndObjectives={iep.iepSteps?.goalsAndObjectives}
                    />;
                case 'step6':
                    return <ReviewView title={t('step6')} subTitle={t('step6Title')} iepId={iep?.iepId ? iep.iepId : ''}
                        firstReview={iep.iepSteps?.firstReview}
                        secondReview={iep.iepSteps?.secondReview}
                        finalReview={iep.iepSteps?.finalReview}
                        mainReview={iep.iepSteps?.finalReview}
                        onGetData={getIEP} step={6}
                        isCompleted={iep.completedSteps?.includes(6)}
                        goalsAndObjectives={iep.iepSteps?.goalsAndObjectives}
                    />;
                case 'step7':
                    return <CheckListAreas checkListArea={iep.iepSteps?.finalChecklist || []}
                        checkListAreaOld={iep.iepSteps?.checkListAreas || []}
                        iepId={iep?.iepId ? iep.iepId : ''} title={t('step7')}
                        subTitle={t('step7Title')} onGetData={getIEP} step={7}
                        isCompleted={iep.completedSteps?.includes(7)}

                    />;


                default:
                    return <Box>No Step Found</Box>


            }
        }
    }


    if (state) {
        const iep: IEP = iepFormAPI ? iepFormAPI : state.iep;
        const parent = state?.student.relationships?.filter((r: RelationShip) => r.relation === Roles.PARENT);
        return (
            <Box p={6}>
                <Flex mb={6} justify="space-between" align="center">
                    <Text fontSize="2xl" fontWeight="900" color="gray.800">
                        {t('iep')} : {iep.year}
                    </Text>
                    <GhostButton leftIcon={<MdArrowBack />} onClick={() => navigate(`/students-profile/${state.student.studentId}`)}>
                        Back
                    </GhostButton>
                </Flex>
                <Card bg="white" border="1px solid #e8e4de" borderRadius="16px" boxShadow="0 1px 4px rgba(0,0,0,0.07), 0 0 0 1px rgba(0,0,0,0.04)" p={6}>
                    <Flex direction={{ base: "column", md: "row" }} gap={{ base: 4, md: 6 }} mb={8} alignItems={{ base: "center", md: "flex-start" }}>
                        <Box display={{ base: 'none', md: 'block' }} w="60px" h="60px" flexShrink={0}>
                            <Avatar
                                borderRadius='full'
                                w="100%"
                                h="100%"
                                name={state.student.fullName}
                                src={state.studentImage}
                            />
                        </Box>
                        <Box flex={1} textAlign={{ base: "center", md: "left" }}>
                            <Text fontWeight={'900'} fontSize={{ base: "22px", md: "28px" }} mb={2}>
                                {state.student.fullName}
                            </Text>
                            <Text fontWeight={'500'} fontSize={{ base: "14px", md: "16px" }} color={'gray.600'} mb={1}>
                                <strong>{t('address')}:</strong> {`${state.student.province}, ${state.student.district}, ${state.student.localLevel}, ${state.student.localAddress}`}
                            </Text>
                            {parent && (
                                <Text fontWeight={'500'} fontSize={{ base: "14px", md: "16px" }} color={'gray.600'} mb={1}>
                                    <strong>{t('parentInformation')}:</strong> {`${parent[0].relatedUser.displayName} (${parent[0].relation}) | ${parent[0].relatedUser.phone}`}
                                </Text>
                            )}
                            <Text fontWeight={'500'} fontSize={{ base: "14px", md: "16px" }} color={'gray.600'}>
                                <strong>{t('level')}:</strong> {iep.level} | <strong>{t('section')}:</strong> {iep.section} | <strong>{t('roll')}:</strong> {iep.roll}
                            </Text>
                        </Box>
                    </Flex>
                    <Box mt={6}>
                        {getComponentByStep()}
                    </Box>
                </Card>
            </Box>
        );
    } else {
        return <Box>Student Not Found</Box>
    }
}
